import Vue from 'vue'
import Vuex from 'vuex'

/*
  page내 keepalive 관리 Vuex
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

const getName = () => {
  return 'keepalive'
}

const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        views: []
      },
      getters: {
        getState: state => {
          return state.views
        }
      },
      mutations: {
        ADD (state, view) {
          // 입력하려는 화면이 배열에 이미 있는지 확인
          var index = state.views.indexOf(view)
          // 없으면
          if (index === -1) {
            // 배열 길이가 4 보다 크면 맨 앞에 꺼 제거
            if (state.views.length >= 4) {
              state.views.shift()
            }
          } else {
            // 있으면 기존 위치에서 제거
            state.views.splice(index, 1)
          }
          state.views.push(view)
        }
      },
      actions: {
        ADD ({commit}, payload) {
          return commit('ADD', payload)
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/keepalive.js